
// @ts-ignore
import { Component, Vue } from 'vue-property-decorator';
import { md } from './const';
import { queryRule, saveRule } from '@/api/protocol-conf';

@Component
export default class ProtocolConf extends Vue {
  submitType?: string;
  iframeStatus = [false, false];
  loading = false;
  iframeInfo = [
    { name: '用户协议', status: false, loading: false, type: 'user_agreement' },
    { name: '隐私政策', status: false, loading: false, type: 'privacy_agreement' },
    { name: '充值提示', status: false, loading: false, type: 'pay_tips' },
  ];

  get iframeUrl() {
    return process.env.VUE_APP_MD_EDITOR_URL;
  }

  // @ts-ignore
  submit(submitType) {
    const index = this.iframeInfo.findIndex(item => item.type === submitType);
    if (!this.iframeInfo[index].status) {
      return;
    }
    this.$set(this.iframeInfo, index, { ...this.iframeInfo[index], loading: true });

    this.submitType = submitType;
    // @ts-ignore
    (this.$refs.iframe as HTMLIFrameElement)[index].contentWindow!.postMessage({ type: 'request-content' }, '*');
  }

  // @ts-ignore
  sendMsgStructure(type, content) {
    return {
      type,
      content,
    };
  }

  queryList = async (title: string) => {
    const { data } = await queryRule({ title });
    const index = this.iframeInfo.findIndex(item => item.type === title);

    // @ts-ignore
    const target = this.$refs.iframe![index] as HTMLIFrameElement;
    if (this.iframeInfo[index].status) {
      // @ts-ignore
      target.contentWindow.postMessage(this.sendMsgStructure('init', { md: data.content || md }), '*');
    } else {
      target.onload = () => {
        this.$set(this.iframeInfo, index, { ...this.iframeInfo[index], status: true });
        // @ts-ignore
        target.contentWindow.postMessage(this.sendMsgStructure('init', { md: data.content || md }), '*');
      };
    }
  };

  mounted() {
    (this.$refs.iframe as any[]).forEach(item => {
      console.log('mmm', item);
      item.onload = () => {
        console.log('aaa2');
        this.$set(this.iframeInfo, item.dataset.index, { ...this.iframeInfo[item.dataset.index], status: true });
      };
    });

    this.loading = true;
    Promise.all([this.queryList('user_agreement'), this.queryList('privacy_agreement'), this.queryList('pay_tips')]).finally(() => (this.loading = false));
    window.addEventListener('message', async event => {
      switch (event.data.type) {
        case 'submit':
          if (!this.submitType) {
            return;
          }
          // @ts-ignore
          await saveRule({ title: this.submitType, content: event.data.content.md }).finally(() => {
            const index = this.iframeInfo.findIndex(item => item.type === this.submitType);
            this.$set(this.iframeInfo, index, { ...this.iframeInfo[index], loading: false });
          });
          this.$message.success('提交成功');
          break;
        default:
          break;
      }
    });
  }
}
